import PropTypes from 'prop-types';
import React from 'react';
import ScrollIntoViewElement from '@99designs/react-components/components/ScrollIntoViewElement';
import Avatar from '@99designs/react-components/components/Avatar';
import CommentField from '@99designs/react-components/components/CommentField';
import RatingSuggestions from './rating-suggestions';

export default class CommentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textValue: '',
            selectedSuggestion: null,
            isAutoFocus: false,
        };

        this.onTextChange = this.onTextChange.bind(this);
        this.useSuggestedComment = this.useSuggestedComment.bind(this);
    }

    render() {
        const submitButtonLabel = <span className="icon icon--sent-1" />;

        return (
            <ScrollIntoViewElement
                scrollingContainer={this.props.scrollingContainer}
                isEnabled={true}
                canScrollOnMount={this.props.canScrollIntoViewOnMount}
            >
                <div>
                    <div className="comment-submit" onClick={this.props.onClick}>
                        {this.props.author && (
                            <div className="comment-submit__avatar">
                                <Avatar
                                    user={this.props.author}
                                    variations={['block', 'extra-small']}
                                />
                            </div>
                        )}
                        <div className="comment-submit__form">
                            <CommentField
                                ref={input => {
                                    this.commentField = input;
                                }}
                                placeholder={this.context.intl.formatMessage({
                                    id: 'comment_form_placeholder',
                                })}
                                layout={this.props.isVertical ? 'vertical' : 'horizontal'}
                                isAutoFocus={this.state.isAutoFocus}
                                submitButtonLabel={submitButtonLabel}
                                submitButtonTooltip={this.context.intl.formatMessage({
                                    id: 'send_message_tooltip',
                                })}
                                cancelButtonLabel={this.context.intl.formatMessage({
                                    id: 'comment_cancel',
                                })}
                                hasCancelButton={this.props.hasCancelButton}
                                onCancel={this.props.onCancel}
                                onSubmit={this.props.onSubmit}
                                onKeyDown={this.props.onKeyDown}
                                onKeyUp={this.props.onKeyUp}
                                onChange={this.onTextChange}
                            />
                        </div>
                    </div>
                    {this.areRatingSuggestionsVisible() && (
                        <RatingSuggestions
                            design={this.props.design}
                            onSuggestionSelected={this.useSuggestedComment}
                        />
                    )}
                </div>
            </ScrollIntoViewElement>
        );
    }

    useSuggestedComment(msg) {
        const suggestion = msg.replace('…', ' ');
        this.commentField.setState({
            textValue: suggestion,
        });

        this.setState(() => {
            return {
                isAutoFocus: true,
                selectedSuggestion: suggestion,
            };
        });
    }

    onTextChange(e) {
        const value = e.target.value;
        this.setState(() => {
            return {
                textValue: value,
            };
        });
    }

    areRatingSuggestionsVisible() {
        return (
            !this.props.hasUserCommented &&
            this.props.design.permission.canViewCommentSuggestions &&
            (this.state.textValue === '' || this.state.textValue === this.state.selectedSuggestion)
        );
    }

    hideRatingSuggestions(e) {
        if (e.target.value.length > 0 && !this.state.isUserTyping) {
            this.setState({ isUserTyping: true });
        } else if (e.target.value.length === 0 && this.state.isUserTyping) {
            this.setState({ isUserTyping: false });
        }
    }
}

CommentForm.contextTypes = {
    intl: PropTypes.object,
};

CommentForm.propTypes = {
    design: PropTypes.object,
    author: PropTypes.object,
    canScrollIntoViewOnMount: PropTypes.bool,
    isVertical: PropTypes.bool,
    isAutoFocus: PropTypes.bool,
    hasCancelButton: PropTypes.bool,
    onCancel: PropTypes.func,
    onClick: PropTypes.func,
    onSubmit: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyUp: PropTypes.func,
    scrollingContainer: PropTypes.object,
    hasUserCommented: PropTypes.bool,
};

CommentForm.defaultProps = {
    design: {},
    canScrollIntoViewOnMount: false,
    hasCancelButton: false,
    isAutoFocus: false,
    isVertical: false,
    onCancel() {},
    onClick() {},
    onSubmit() {},
    onKeyDown() {},
    onKeyUp() {},
    hasUserCommented: false,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/comment-form.jsx